/**
 * @file habo上报
 * @author yuanyaojia<yuanyaojia@baijia.com>
 * @date 2021-06-29
 */
import habo from 'habo';
import {parseCookie} from '../cookie';

const {GID} = parseCookie();

habo.setConfig({
    NAME: 'yy-investor',
    // 擎天服务树标识
    APPNID: 'baijia.base-tech.qyxn.touzizhe.investor-fe',
    userId: GID,
    trackID: GID,
});

habo.perf({});

/**
  * habo 点击上报
  *
  * @param {number} eventId 用户ID
  * @param {number} loggerId 页面路由
  * @param {number} userId 来源
  * @param {number} index 文件路径
  * @param {number} trackID 文件路径
  */

export const haboClick = (eventId, rest) => {
    habo.click({
        eventId,
        loggerId: 0,
        ...rest
    });
};

export const haboView = (eventId, userId = GID, rest) => {
    habo.view({
        eventId,
        pageUrl: location.href,
        referrer: document.referrer,
        userNumber: userId,
        pageStr: '',
        ...rest,
    });
};
